import AuthRouter from './AuthRouter';

const AuthPage: React.FC = () => {
  return <AuthRouter />;
};
export default AuthPage;
